import { API_URL } from "env";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { t } from "i18next";
const tempData = [
    {
        id: 1,
        paymentId: "#654321",
        image: "https://images.pexels.com/photos/6801648/pexels-photo-6801648.jpeg",
        botName: "ScalperPro EA",
        customerEmail: "ABC@gmail.com",
        platform: "MetaTrader 4",
        amount: "$299",
        originalAmount: "$399",
        date: "Dec 15, 2024, 05:30 PM",
        status: "completed",
        paymentMethod: "PayPal"
    },
    {
        id: 2,
        paymentId: "#123456",
        image: "https://images.pexels.com/photos/6801648/pexels-photo-6801648.jpeg",
        botName: "TrendMaster EA",
        customerEmail: "dec@mda",
        platform: "cTrader",
        amount: "$199",
        originalAmount: "$249",
        date: "Nov 20, 2024, 03:15 PM",
        status: "completed",
        paymentMethod: "Credit Card"
    },
]
interface HistoryItems {
    id: number;
    paymentId: string;
    productData: any;
    customerEmail: string;
    amount: string;
    date: string;
    status: 'succeeded' | 'pending' | 'failed';
    paymentMethod: string;
}
const InventoryBuyHistory = () => {
    const [historyItems, setHistoryItems] = useState<HistoryItems[]>([]);
    const user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user') || '{}') : null;
    const { t, i18n } = useTranslation();
    const language = i18n.language || 'en';
    async function fetchHistory() {
        try {
            if (!user || !user.id) return [];
            const res = await fetch(API_URL + `/api/v1/be/payments?user_id=${user.id}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token') || ''}`,
                }
            })
            const data = await res.json();
            const dataReturn = await Promise.all(
                data.data.items.map(async (his: any) => {
                    const product = his.meta.tool_id ? await fetchToolData(his.meta.tool_id) : null;
                    return {
                        id: his.id,
                        paymentId: his.external_ref,
                        productData: product,
                        amount: his.amount_formatted,
                        date: new Date(his.created_at).toLocaleString(),
                        status: his.status,
                        paymentMethod: his.provider
                    };
                })
            );

            setHistoryItems(dataReturn);

        }
        catch (error) {
            console.error('Error while fetchHistory', error)
            return null
        }
    }

    async function fetchToolData(id: number) {
        try {
            const res = await fetch(API_URL + `/api/v1/be/tools/${id}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token') || ''}`,
                }
            })
            const data = await res.json();
            return data.data;
        }
        catch (error) {
            console.error('Error while fetching tool data', error)
        }
    }

    useEffect(() => {
        fetchHistory();
    }, [])

    return (
        <div className="space-y-4">
            <table className="min-w-full divide-y divide-gray-200 inventory-table rounded-lg shadow-md">
                <thead className="inventory-table-header">
                    <tr>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">{t("inventory_purchased_product")}</th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">{t("inventory_purchase_platform")}</th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">{t("inventory_purchase_amount")}</th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">{t("inventory_purchase_date")}</th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">{t("inventory_purchase_status")}</th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">{t("inventory_purchase_payment")}</th>
                    </tr>
                </thead>
                <tbody className="divide-y divide-gray-200">
                    {historyItems.map((item) => (
                        <tr key={item.id} className="inventory-item-card transition-colors duration-200 cursor-pointer" 
                            onClick={() => {
                                window.open(`/profile/inventory/${item?.id}`, '_self');
                            }}
                        >
                            <td className="px-6 py-4 whitespace-nowrap flex items-center gap-3">
                                <div className="h-20 w-20 rounded-lg overflow-hidden bg-gray-100 inventory-item-card relative">
                                    <img src={item?.productData?.image_url} alt={item?.productData?.title[language]}
                                        className="w-20 h-20 object-cover rounded inventory-item-card"
                                        onLoad={e => {
                                            const target = e.currentTarget as HTMLImageElement;
                                            target.style.transition = 'opacity 300ms ease-in';
                                            target.style.opacity = '1';

                                            // remove any loading placeholder/overlay if present
                                            const placeholder = target.parentElement?.querySelector('.img-loading, .loading-svg, .loading-placeholder') as HTMLElement | null;
                                            if (placeholder) placeholder.remove();
                                        }}
                                        onError={e => {
                                            const target = e.currentTarget as HTMLImageElement;
                                            // prevent repeated error handling
                                            target.onerror = null;
                                            // hide the broken image element
                                            target.style.display = 'none';

                                            // remove any loading placeholder/overlay if present
                                            const placeholder = target.parentElement?.querySelector('.img-loading, .loading-svg, .loading-placeholder') as HTMLElement | null;
                                            if (placeholder) placeholder.remove();

                                            // only add one fallback element
                                            if (!target.parentElement?.querySelector('.img-fallback')) {
                                                const fallback = document.createElement('div');
                                                fallback.className = "img-fallback h-20 w-20 inset-0 flex items-center justify-center";
                                                fallback.innerHTML = `
                                                            <div class="flex flex-col items-center w-20 h-20">
                                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256"><rect width="10" height="10" fill="none"/><path d="M104,208H40a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V88l-48,16-16,40-40,16Z" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><path d="M137.73,208l7.94-23.8,39-15.58,15.58-39,23.8-7.94V200a8,8,0,0,1-8,8Z" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><path d="M32,168.69l54.34-54.35a8,8,0,0,1,11.32,0l39,39" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/></svg>    
                                                            </div>    
                                                        `;
                                                target.parentNode?.appendChild(fallback);
                                            }
                                        }}
                                    />
                                </div>
                                <div className="flex flex-col">
                                    <span className="text-sm text">{item?.productData?.title[language]}</span>
                                    <p className="!mb-0 !text-xs text-muted ">{item?.paymentId}</p>
                                </div>
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-muted">{item?.productData?.platform}</td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text font-semibold">{item?.amount} {item?.productData?.price_finalize && <span className="text-gray-500 line-through text-sm font-normal ml-2">{item.productData.price_finalize}</span>}</td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-muted">{item?.date}</td>
                            <td className="px-6 py-4 whitespace-nowrap">
                                {item?.status === 'succeeded' ? (
                                    <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800">Completed</span>
                                ) : item?.status === 'pending' ? (
                                    <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-yellow-200 text-yellow-800">Pending</span>
                                ) : (
                                    <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-red-100 text-red-800">Failed</span>
                                )}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-center text">{item?.paymentMethod.toUpperCase()}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    )
};

export default InventoryBuyHistory;